<template>
  <label
    :for="id"
    :class="[
      'VisionCheckbox',
      {
        'VisionCheckbox--radio': type === 'radio',
        'VisionCheckbox--disabled': disabled,
        'VisionCheckbox--checked': checked,
        'VisionCheckbox--error': error,
        'VisionCheckbox--no-label': !labelText && !$slots.default
      },
    ]"
  >
    <div class="VisionCheckbox__checkmark" />
    <slot />
    <template v-if="!$slots.default">
      <span class="VisionCheckbox__label-text">{{ labelText }}</span>
    </template>
    <input
      :id="id"
      v-model="model"
      :name="name"
      :value="inputValue"
      :disabled="disabled"
      :type="type"
      class="VisionCheckbox__hidden-input"
    />
  </label>
</template>

<script>
export default {
  name: "VisionCheckbox",

  props: {
    id: {
      type: String,
      default: "",
      required: true,
    },
    labelText: {
      type: String,
      default: "",
      required: false,
    },
    name: {
      type: String,
      default: "",
      required: false,
    },
    modelValue: {
      type: [Boolean, Array, String],
      default: false,
      required: false,
    },
    inputValue: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'checkbox',
      validator(value) {
        return ['checkbox', 'radio'].includes(value)
      }
    }
  },

  emits: ['update:modelValue'],

  computed: {
    model: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit("update:modelValue", value)
      },
    },

    checked() {
      if (Array.isArray(this.modelValue)) {
        const arrayToFilterOn = this.modelValue

        return (
          arrayToFilterOn.filter((value) => value === this.inputValue)
            .length === 1
        )
      }

      if (this.type === "radio") {
        return this.modelValue === this.inputValue
      }

      else if (this.type === "checkbox") {
        return this.modelValue
      }

      return false
    },
  },
}
</script>

<style lang="postcss">
.VisionCheckbox {
  @apply text-xs flex items-start cursor-pointer;

  &--disabled {
    @apply opacity-50 cursor-not-allowed;
  }
}

.VisionCheckbox--checked {
  .VisionCheckbox__checkmark {
    &::after {
      background: var(--gradient-default);
      opacity: 1;
    }
  }
}

.VisionCheckbox--error {
  .VisionCheckbox__checkmark {
    @apply border-red;
  }

  .VisionCheckbox__label-text {
    @apply text-red;
  }
}

.VisionCheckbox--radio {
  .VisionCheckbox__checkmark {
    @apply rounded-full;

    &::after {
      @apply rounded-full;
    }
  }
}

.VisionCheckbox--no-label {
  .VisionCheckbox__checkmark {
    @apply mr-0;
  }
}

.VisionCheckbox__label-text {
  @apply text-xxs ml-2 block;
}

.VisionCheckbox__hidden-input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.VisionCheckbox__checkmark {
  @apply mr-2 relative h-5 w-5 shrink-0;

  background-color: theme("colors.white");
  border-radius: 4px;
  padding: 0 !important;
  border: 1px solid theme("colors.black");

  &:after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 14px;
    height: 14px;
    border-radius: 2px;
    background: theme("colors.white");
  }
}
</style>
